import React, { useState,useEffect } from 'react';
import DeHubOrderListTable from './OrdersList';

export default function DeOrderTabs({ orderCunt }) {
  const [index, setIndex] = useState(0);
  const [searchTxt, setSearchTxt] = useState("");

  const handleChange = (newValue) => {
    setIndex(newValue);
  };

  const handleOrderSearch = async (e) => {
    setSearchTxt(e.target.value)
  };
  useEffect(() => {
    console.log("Order Count Updated:", orderCunt);
  }, [orderCunt]);

  return (
    <div className="category-container mt-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <div>
          <button className={index === 0 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(0)}>All Orders</button>
          <button className={index === 1 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(1)}>Submitted</button>
          <button className={index === 2 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(2)}>Getting Packed</button>
          <button className={index === 3 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(3)}>Packed</button>
          <button className={index === 4 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(4)}>Ready For Pickup</button>
          <button className={index === 5 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(5)}>Out For Delivery</button>
          <button className={index === 6 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(6)}>Completed</button>
          <button className={index === 7 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(7)}>Outlet Canceled</button>
        </div>
        <div className="table-search">
          <div className="search-container">
            <input onChange={(e) => handleOrderSearch(e)}
              type="search"
              placeholder="Search.."
              ame="search"
              autoFocus
            />

          </div>
        </div>
      </div>
      <div>
        {index === 0 ? (
          <DeHubOrderListTable key={index} status="all" searchTxt={searchTxt} orderCunt={orderCunt} />
        ) : index === 1 ? (
          <DeHubOrderListTable key={index} status="submitted" orderCunt={orderCunt} />
        ) : index === 2 ? (
          <DeHubOrderListTable key={index} status="getting-packed" orderCunt={orderCunt} />
        ) : index === 3 ? (
          <DeHubOrderListTable key={index} status="packed" orderCunt={orderCunt} />
        ) : index === 4 ? (
          <DeHubOrderListTable key={index} status="ready-for-pickup" orderCunt={orderCunt} />
        ) : index === 5 ? (
          <DeHubOrderListTable key={index} status="out-for-delivery" orderCunt={orderCunt} />
        ) : index === 6 ? (
          <DeHubOrderListTable key={index} status="completed" orderCunt={orderCunt} />
        ) : index === 7 ? (
          <DeHubOrderListTable key={index} status="hub-canceled" orderCunt={orderCunt} />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
